import { TextField, Typography } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import StaticField from "../../components/StaticField";
import { LearningSet } from "../../models/ProgramRequest/LearningSet";
import { Module } from "../../models/ProgramRequest/Module";
import { programRequestMzoUrl } from "../../routes/routes";
import styles from "./ProgramRequestMzo.module.scss";

type ProgramRequestModuleProps = {
  programRequestId: number;
  requestModules: Module[];
  requestCorrectionModules: Module[];
  getErrorForPath: (path: string) => string | undefined;
  onChange: (e: any) => void;
}
export default function ProgramRequestModuleEditor({
  programRequestId,
  requestModules,
  requestCorrectionModules,
  getErrorForPath,
  onChange }: ProgramRequestModuleProps): JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();

  if (!requestCorrectionModules || requestCorrectionModules.length === 0) {
    requestCorrectionModules = JSON.parse(JSON.stringify(requestModules));
  }
  else if (requestModules.length > requestCorrectionModules.length) {
    let destinationCount = requestCorrectionModules.length;
    for (let i = destinationCount; i < requestModules.length; i++) {
      requestCorrectionModules.push(JSON.parse(JSON.stringify(requestModules[i])));
    }
  }

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    var modules = requestCorrectionModules.slice();

    modules[index].name = event.target.value;

    onChange({
      ...event,
      target: {
        ...event.target,
        name: event.target.value,
        value: modules
      }
    });
  }

  const handleChangeLearningSetName = (event: React.ChangeEvent<HTMLInputElement>, index: number, learningSetIndex: number) => {
    var learningSets = requestCorrectionModules[index].learningSets.slice()
    var learningSet = learningSets[learningSetIndex];

    learningSet.name = event.target.value;

    onChange({
      ...event,
      target: {
        ...event.target,
        name: event.target.value,
        value: learningSets
      }
    });
  }

  const handleChangeLearningSetCode = (event: React.ChangeEvent<HTMLInputElement>, index: number, learningSetIndex: number) => {
    var learningSets = requestCorrectionModules[index].learningSets.slice()
    var learningSet = learningSets[learningSetIndex];

    var code = event.target.value;
    learningSet.code = event.target.value;

    onChange({
      ...event,
      target: {
        ...event.target,
        code: code,
        value: learningSets
      }
    });
    history.push(programRequestMzoUrl(programRequestId));
  }

  const handleChangeLearningSetLevel = (event: React.ChangeEvent<HTMLInputElement>, index: number, learningSetIndex: number) => {
    var learningSets = requestCorrectionModules[index].learningSets.slice()
    var learningSet = learningSets[learningSetIndex];

    learningSet.level = parseInt(event.target.value);

    onChange({
      ...event,
      target: {
        ...event.target,
        level: event.target.value,
        value: learningSets
      }
    });
    history.push(programRequestMzoUrl(programRequestId));
  }

  const handleChangeLearningSetCsvet = (event: React.ChangeEvent<HTMLInputElement>, index: number, learningSetIndex: number) => {
    var learningSets = requestCorrectionModules[index].learningSets.slice()
    var learningSet = learningSets[learningSetIndex];

    var csvet = event.target.value ? parseInt(event.target.value) : 0;
    learningSet.csvet = csvet;

    onChange({
      ...event,
      target: {
        ...event.target,
        csvet: csvet,
        value: learningSets
      }
    });
    history.push(programRequestMzoUrl(programRequestId));
  }

  return (
    <>
      <Row>
        <Col md={12} className={styles.rowTitleSpacing}>
          <Typography variant="smallHeading" component="h3">
            {t("request.modules")}
          </Typography>
        </Col>
      </Row>
      {requestModules.map((module: Module, index) => (
        <div className={styles.modulePanel}>
          <Row>
            <Col md={12} className={styles.learningSetDataCol}>
              <StaticField
                label={t("request.moduleName")}
                value={module.name}
              />
            </Col>
          </Row>
          <Row className={styles.learningSetEditRow}>
            <Col md={12}>
              <TextField
                value={requestCorrectionModules[index].name}
                onChange={(e) => handleNameChange(e, index)}
                maxLength={255}
                errorText={getErrorForPath(`destinationValues${index}.name`)}
              />
            </Col>
          </Row>
          {module.learningSets.map((learningSet: LearningSet, learningSetIndex) => (
            <>
              <Row className={styles.learningSetDataRow}>
                <Col md={6} className={styles.learningSetDataCol}>
                  <StaticField
                    label={t("request.moduleLearningSetName")}
                    value={learningSet.name}
                  />
                </Col>
                <Col md={2} className={styles.learningSetDataCol}>
                  <StaticField
                    label={t("request.moduleLearningSetCode")}
                    value={learningSet.code}
                  />
                </Col>
                <Col md={2} className={styles.learningSetDataCol}>
                  <StaticField
                    label={t("request.moduleLearningSetLevel")}
                    value={learningSet.level}
                  />
                </Col>
                <Col md={2} className={styles.learningSetDataCol}>
                  <StaticField
                    label={t("request.moduleLearningSetCSVET")}
                    value={learningSet.csvet}
                  />
                </Col>
              </Row>
              <Row className={styles.learningSetEditRow}>
                <Col md={6}>
                  <TextField
                    value={requestCorrectionModules[index].learningSets[learningSetIndex].name}
                    maxLength={255}
                    onChange={(e) => handleChangeLearningSetName(e, index, learningSetIndex)}
                    errorText={getErrorForPath(`destinationValues${index}.learningSet${learningSetIndex}.name`)}
                  />
                </Col>
                <Col md={2}>
                  <TextField
                    value={requestCorrectionModules[index].learningSets[learningSetIndex].code}
                    onChange={(e) => handleChangeLearningSetCode(e, index, learningSetIndex)}
                    errorText={getErrorForPath(`destinationValues${index}.learningSet${learningSetIndex}.code`)}
                  />
                </Col>
                <Col md={2}>
                  <TextField
                    value={requestCorrectionModules[index].learningSets[learningSetIndex].level}
                    type="number"
                    min={2}
                    max={6}
                    onChange={(e) => handleChangeLearningSetLevel(e, index, learningSetIndex)}
                    errorText={getErrorForPath(`destinationValues${index}.learningSet${learningSetIndex}.level`)}
                  />
                </Col>
                <Col md={2}>
                  <TextField
                    value={requestCorrectionModules[index].learningSets[learningSetIndex].csvet}
                    type="number"
                    min={1}
                    onChange={(e) => handleChangeLearningSetCsvet(e, index, learningSetIndex)}
                    errorText={getErrorForPath(`destinationValues${index}.learningSet${learningSetIndex}.csvet`)}
                  />
                </Col>
              </Row>
            </>
          ))}
        </div>
      ))}
    </>
  );
}